import { GeoGeoableData } from "@/common/types/geoGeoable"

export const transformNewGeos = (geo: { value?: string, type?: string }) => ({
  geo_id: geo.value, 
  geo_type: geo.type,
})

export const transformGeosToOptions = (geos: GeoGeoableData[]) => (
  geos.map((geo) => ({ label: geo.geo.display_name, value: geo.geo.id, type: geo.geo_type }))
)